export default {
    'name': 'Loader-Component',
}